import { render, staticRenderFns } from "./sinformation.vue?vue&type=template&id=4ea02e08&scoped=true&"
import script from "./sinformation.vue?vue&type=script&lang=js&"
export * from "./sinformation.vue?vue&type=script&lang=js&"
import style0 from "./sinformation.vue?vue&type=style&index=0&id=4ea02e08&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ea02e08",
  null
  
)

export default component.exports